import axios from "axios";
import * as actionType from "../../../constant/actionType";
export const GetAllProviderTypeList = (apidata) => async (dispatch) => {
  /*** API Call Action ***/
  try {
    const response = await axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/admin/client/GetAllProviderTypeListForReport`,
      params: apidata,
    });
    return response.data;
  } catch (error) {
    return error.message;
  }
};
